import posthog from "posthog-js"

const posthogToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN
const isLocalHost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname)
const disableLocalPostHog = process.env.NEXT_PUBLIC_POSTHOG_DISABLE_LOCAL !== "false"
const locallyDisabled = isLocalHost && disableLocalPostHog

if (posthogToken) {
  posthog.init(posthogToken, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    defaults: "2026-01-30",
    capture_exceptions: !locallyDisabled,
    debug: process.env.NODE_ENV === "development" && !locallyDisabled,
    capture_pageview: locallyDisabled ? false : undefined,
    capture_pageleave: locallyDisabled ? false : undefined,
    autocapture: locallyDisabled ? false : undefined,
    opt_out_capturing_by_default: locallyDisabled,
    advanced_disable_flags: locallyDisabled,
    disable_session_recording: locallyDisabled,
    disable_surveys: locallyDisabled,
    disable_external_dependency_loading: locallyDisabled,
    // Session replay must also be enabled in the PostHog project settings to start
    // recording. When it is, mask everything: this is a life planner, so we never
    // want the words people type (goals, finances, journal entries) captured. With
    // these settings replays show navigation/clicks but all text and inputs are
    // masked, keeping the content of planner entries out of recordings entirely.
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "*",
    },
  })
}
